var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTextToImage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "text-to-image"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 11C10 9.89543 10.8954 9 12 9H20C21.1046 9 22 9.89543 22 11V19C22 20.1046 21.1046 21 20 21H12C10.8954 21 10 20.1046 10 19V11ZM15.4142 19H20V18.4142L18 16.4142L15.4142 19ZM20 15.5858L19.4142 15C18.6332 14.219 17.3668 14.219 16.5858 15L12.5858 19H12V11H20V15.5858Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5 13.25C15.5 13.9404 14.9404 14.5 14.25 14.5C13.5596 14.5 13 13.9404 13 13.25C13 12.5596 13.5596 12 14.25 12C14.9404 12 15.5 12.5596 15.5 13.25Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1 5C1 3.89543 1.89543 3 3 3H9C10.1046 3 11 3.89543 11 5C11 5.55228 10.5523 6 10 6C9.44772 6 9 5.55228 9 5H7V12C7.55228 12 8 12.4477 8 13C8 13.5523 7.55228 14 7 14H5C4.44772 14 4 13.5523 4 13C4 12.4477 4.44772 12 5 12V5H3C3 5.55228 2.55228 6 2 6C1.44772 6 1 5.55228 1 5Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.7552 2.15769C20.6501 1.94744 20.35 1.94744 20.2449 2.15769C19.5905 3.46646 19.4665 3.5905 18.1577 4.24488C17.9474 4.35001 17.9474 4.65005 18.1577 4.75518C19.4665 5.40956 19.5905 5.5336 20.2449 6.84237C20.35 7.05262 20.6501 7.05262 20.7552 6.84237C21.4096 5.5336 21.5336 5.40956 22.8424 4.75518C23.0526 4.65005 23.0526 4.35001 22.8424 4.24488C21.5336 3.5905 21.4096 3.46646 20.7552 2.15769Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.2645 4.16345C15.1555 3.94552 14.8445 3.94552 14.7355 4.16345C14.2499 5.13469 14.1347 5.24991 13.1635 5.73553C12.9455 5.8445 12.9455 6.1555 13.1635 6.26447C14.1347 6.75009 14.2499 6.86532 14.7355 7.83655C14.8445 8.05448 15.1555 8.05448 15.2645 7.83655C15.7501 6.86532 15.8653 6.75009 16.8365 6.26447C17.0545 6.1555 17.0545 5.8445 16.8365 5.73553C15.8653 5.24991 15.7501 5.13468 15.2645 4.16345Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.75514 16.1577C4.65002 15.9474 4.34998 15.9474 4.24486 16.1577C3.59048 17.4664 3.46644 17.5905 2.15769 18.2449C1.94744 18.35 1.94744 18.65 2.15769 18.7551C3.46644 19.4095 3.59048 19.5336 4.24486 20.8423C4.34998 21.0526 4.65002 21.0526 4.75514 20.8423C5.40952 19.5336 5.53356 19.4095 6.84231 18.7551C7.05256 18.65 7.05256 18.35 6.84231 18.2449C5.53356 17.5905 5.40952 17.4664 4.75514 16.1577Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTextToImage);
export default __webpack_public_path__ + "static/media/text-to-image.a190343e8bf50c956ec69e2117d65796.svg";
export { ForwardRef as ReactComponent };